/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EDocumentationStatus } from "../types/EDocumentationStatus.ts";

/**
 * @description 0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary |
 */
export const eDocumentationStatusSchema = z
  .union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
  ) as unknown as ToZod<EDocumentationStatus>;
